import { dateFormatDay } from "./../utils/dateFormat";

export default function devextremeDateFormatHelper() {
    (function (window) {
        /**
         * Formats a date time string to a display value.
         * @param {String} dateTimeString
         * @returns {String}
         */
        function dateStringToDisplayValue(dateTimeString) {
            if (!dateTimeString || dateTimeString === "0001-01-01T00:00:00") {
                return null;
            }

            return dateFormatDay(dateTimeString);
        }

        /**
         * Formats a date object to a standardized date string for Devextreme Data Grid Rows UpdatedAt value.
         * @param {Object} rowData
         */
        window.calculateUpdatedAtDisplayValue = function (rowData) {
            const updatedAt = rowData.UpdatedAt ?? rowData.updatedAt;
            return dateStringToDisplayValue(updatedAt);
        }

        /**
         * Formats a date object to a standardized date string for Devextreme Data Grid Rows CreatedAt value.
         * @param {Object} rowData
         */
        window.calculateCreatedAtDisplayValue = function (rowData) {
            const createdAt = rowData.CreatedAt ?? rowData.createdAt;
            return dateStringToDisplayValue(createdAt);
        }

        /**
         * Formats a date object to a standardized date string for Devextreme Data Grid Rows key value.
         * @param {Object} rowData
         * @param {String} key
         */
        window.calculateDateDisplayValue = function (rowData, key) {
            const date = rowData[key];
            return dateStringToDisplayValue(date);
        }
    })(window);
}